import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { AuthService } from '../../../services/auth.services'
import { ModalService } from '../../../services/modal.service'
import { SharedServices } from '../../../services/shared.services'
import { ClientDetailServices } from '../../../services/ClientDetail.services'
import { RestServices } from '../../../services/rest.services'
import { SlideInOutAnimation } from './../../../animations'
import { notification, openActionSheet } from 'onsenui'
import { ClientTopServices } from '../../../services/ClientTop.services'
import { StateServices } from '../../../services/state.services'
import * as moment from 'moment'
import { MatrixServices } from '../../../services/image/matrix.services'
import { AlignerHelper } from '../../../../helper/aligner.helper'

@Component({
    selector: 'app-client-detail',
    templateUrl: './client-detail.component.html',
    styleUrls: [
        './client-detail.component.css',
        '../../../stagingcss/main-body.component.css',
        '../../../stagingcss/lui-select.component.css',
    ],
    animations: [SlideInOutAnimation],
    host: {
        '(document:click)': 'onClick($event)',
    },
})
export class ClientDetailComponent implements OnInit, OnDestroy {
    @ViewChild('klinUrl') klinUrl: ElementRef
    idClient
    clientInfo: any
    resourceUrl = 'resource'
    homeProfileAligber = ''
    profile
    PosisinScreen
    animationState = 'out'
    planClass
    showIt: any = 'option_Slideshow'
    arayListNote: any
    clientInfoUrl = []
    contentNote
    hiddenWhenFullscreen = ''
    textareaNote: boolean = true
    arrTabImageTmp: any[] = [
        {
            id: 0,
            name: 'Registration',
            nameSave: 'Registration',
            forearch: 'option_Registration',
            nameLanguge: 'app-client-detail-top-Registration',
        },
        {
            id: 1,
            name: 'Slideshow',
            nameSave: 'Slideshow',
            forearch: 'option_Slideshow',
            nameLanguge: 'app-client-detail-top-Slideshow',
        },
        {
            id: 2,
            name: 'Comparison',
            nameSave: 'Comparison',
            forearch: 'option_Comparison',
            nameLanguge: 'app-client-detail-top-Comparison',
        },
        {
            id: 3,
            name: 'Simulation',
            nameSave: 'Simulation',
            forearch: 'option_Simulation',
            nameLanguge: 'app-client-detail-top-Simulation',
        },
    ]

    arrTabImage: any[] = []

    arrPresentationTabImage: any[] = [
        {
            id: 1,
            name: 'Slideshow',
            nameSave: 'Slideshow',
            forearch: 'option_Slideshow',
            nameLanguge: 'app-client-detail-top-Slideshow',
        },
        {
            id: 2,
            name: 'Comparison',
            nameSave: 'Comparison',
            forearch: 'option_Comparison',
            nameLanguge: 'app-client-detail-top-Comparison',
        },
        {
            id: 3,
            name: 'Simulation',
            nameSave: 'Simulation',
            forearch: 'option_Simulation',
            nameLanguge: 'app-client-detail-top-Simulation',
        },
    ]
    index: any = 0
    indexNote
    arrAllClientTop: any = [] = []
    countArrAllClientTop: any = 0
    tabName: any
    emitTabName: any = {}
    arrNoteList: any[] = []
    checkDatachenageLocal: boolean

    page: any = 'slideshow'
    showTextareaNote: any
    arrSimulation: any[] = []
    en: any = {}
    showEN = true
    arrTmpArrClientTop: any[] = []
    nameDoctor
    firstDate
    lastDate
    birthday
    cordinator
    accountDate
    wearingTime
    accelationDevice
    alignerParamDay
    alignerInterval
    alignerCount
    alignerAll
    alignerTitle
    nameClinic
    showAge
    operator
    presentationName: any
    isPresentation: Boolean = false
    initIndex: any = 'init'
    klinActive = false
    showRegistrationMode = true
    phaseNumber = AlignerHelper.PHASE_NUMBERS

    phaseByName = AlignerHelper.PHASE_BY_NAMES
    unscrIsCreate
    unscrTabName
    // unscrUpdateData;
    isLoadingChangeTabName = false
    nowPage = ''
    showClinCheck: boolean = false
    faceImage

    constructor(private auth: AuthService, private _clientDetailServices: ClientDetailServices, private router: Router, private restApi: RestServices, private _sharedService: SharedServices,
                private modalservice: ModalService, private route: ActivatedRoute, private clientTopServices: ClientTopServices, private stateServices: StateServices,
                private matrixServices: MatrixServices) {
        this.homeProfileAligber = 'hidden'
        this.hiddenWhenFullscreen = 'active'
        this.contentNote = ''
    }

    ngOnInit() {
        this.matrixServices.resetMatrix()
        this.arrTabImage = this.arrTabImageTmp
        this.clientTopServices.emitChangePage(this.page)
        this.showIt = 'option_Slideshow'
        this.planClass = 'option_Slideshow'
        this.showTextareaNote = 'hidden'
        this.clientTopServices.changeEmiitedInit$.subscribe(init => {
            if (init != null && init != undefined && init['init'] != undefined && init['init'] != '') {
                this.initIndex = init['init']
            } else {
                this.initIndex = ''
            }
        })
        this.route.parent.paramMap.subscribe((params: ParamMap) => {
            if (params.get('id') != undefined && params.get('id') != '') {
                const id = params.get('id')
                this.idClient = id
            } else {
                this.idClient = localStorage.getItem('idClient')
            }
            this._sharedService.getIdParam(this.idClient)
            if (!this.isLoadingChangeTabName) {
                // this.callApiInfoClient(this.idClient);
                // this.callApiInfoTopClient(this.idClient, 'init');
                this.callApiInfoClientDetail(this.idClient, 'init');
            }
            this.clientTopServices.emitChangeChangeStatus(false)
            this.clientTopServices.emitChangeValueSlider(100)
            this.clientTopServices.emitChangeSlider(100)
            this.clientTopServices.emitChangeListTopImageData(null)
        })
        this.checkChangeRefreshData()
        // this.getDataAfterDeleteFormModal();
        //this.getDataNoteTextAfterChangeDataRecrond()
        this.getDataNoteTextBefore()
        this.getDataDeleteRecorndLast()
        this.getListNote()
        this.getPresentationMode()
        this.getDataAllWhenCreate()
        this.getNowPage()
        this.changeTabName()
    }

    ngOnDestroy() {
        this.isLoadingChangeTabName = false
        // this.unscrUpdateData.unsubscribe();
        if(this.unscrIsCreate)
            this.unscrIsCreate.unsubscribe()
        if(this.unscrTabName)
            this.unscrTabName.unsubscribe()
        this.resetStateServices()
    }

    getNowPage() {
        this.clientTopServices.changeEmiitedPage$.subscribe(resNowPage => {
            if (resNowPage) {
                this.nowPage = resNowPage
            }
        })
    }

    getDataAllWhenCreate() {
        this.unscrIsCreate = this.clientTopServices.changeEmiitedIsCreated$.subscribe(create => {
            if (create != null && create['create'] != undefined) {
                this.callApiUpdateDataAll(this.idClient)
                this.clientTopServices.emitChangeIsCreated(null)
            }
        })
    }

    callApiUpdateDataAll(idClient) {
        const clientIdVisit = {}
        const result = '{"clientId":"' + this.idClient + '"}'
        clientIdVisit[result] = true
        const clientInfor = {}
        const resultClientInfor = idClient
        clientInfor[resultClientInfor] = true
        const resourceDataInfoTopclinet = {
            actions: [],
            status: {
                client: {
                    map: clientInfor,
                },
                clientVisit: {
                    paths: clientIdVisit,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataInfoTopclinet, tokenReNew).subscribe(
                success => {
                    this.arrTmpArrClientTop = success['response']['clientVisit']['paths']['' + result]
                    this.countArrAllClientTop = success['response']['clientVisit']['paths']['' + result].length
                    if (this.countArrAllClientTop > 0) {
                        this.arrTmpArrClientTop = this.clientTopServices.changeDateStringToDecoe(this.arrTmpArrClientTop)
                        this.arrTmpArrClientTop.sort((function(obj1, obj2) {
                            return parseFloat(obj1['dateStringToInit']) - parseFloat(obj2['dateStringToInit'])
                        }))
                    }
                },
            )
        })
    }

    resetStateServices() {
        this.matrixServices.resetMatrix()
        this.stateServices.emitChangeHash(null)
        this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
        this.clientTopServices.changecheckDataAfterConfirm(null)
        this.clientTopServices.showClientArrayTop(null)
        this.clientTopServices.emitChangeArrCopy(null)
        this.clientTopServices.emitChangeListTopImageData(null)
        this.clientTopServices.emitChangeChangeStatus(null)
        this.clientTopServices.emitChangeParent(null)
        this.clientTopServices.emitChangeIndexToGetNote(null)
        this.clientTopServices.emitChangeRefresh(null)
        this.clientTopServices.emitChange(null)
        this.clientTopServices.emitChangeSlider(null)
        this.clientTopServices.emitChangeValueSlider(null)
        this.clientTopServices.emitChangeHash(null)
        this.clientTopServices.emitChangeStyle(null)
        this.clientTopServices.emitChangeRefreshArr(null)
        this.clientTopServices.emitChangeSlideshow(null)
        this.clientTopServices.emitGetFaceImage(null)
        this.clientTopServices.emitChangeInfoUrlChange(null)
        this.clientTopServices.emitChangeNoteList(null)
        this.clientTopServices.emitChangeNote(null)
        this.clientTopServices.emitChangeViewDetailUser(null)
        this.clientTopServices.emitChangeActiveIndex(null)
        this.clientTopServices.emitChangePreventationName(null)
        this.clientTopServices.resetChangeInit()
        this.clientTopServices.changecheckDataAfterConfirm(false)
        this.clientTopServices.resetAllArrClientTop()
        this.clientTopServices.emitChangeIsCreated(null)
        this.clientTopServices.resetTabName()
        this.clientTopServices.resetIndex()
        this.clientTopServices.emitChangeArrSimulation(null)
    }

    onClick(event) {
        if (event.target.className.indexOf('tag-button') == -1 && this.klinUrl && !this.klinUrl.nativeElement.contains(event.target)) {
            this.klinActive = false
        }
    }

    getPresentationMode() {
        this._sharedService.changeEmittedPresentationModeSearchData$.subscribe(presentation => {
            if (presentation != null) {
                const arrTmp: any[] = presentation
                if (arrTmp.length > 0 && arrTmp[1] != undefined) {
                    if (arrTmp[0] == 'arraySearchPresentationMode-selectData' && arrTmp[1] == true) {
                        this.arrTabImage = this.arrPresentationTabImage
                        this.isPresentation = arrTmp[1]
                    } else if (arrTmp[0] == 'arraySearchPresentationMode-selectData' && arrTmp[1] == false) {
                        this.arrTabImage = this.arrTabImageTmp
                        this.isPresentation = arrTmp[1]
                    }
                }
            } else {
                const local: any = localStorage.getItem('presentationModeValue')
                if (local == 'true') {
                    this.arrTabImage = this.arrPresentationTabImage
                    this.isPresentation = true
                } else if (local == 'false') {
                    this.arrTabImage = this.arrTabImageTmp
                    this.isPresentation = false
                } else {
                    this.arrTabImage = this.arrTabImageTmp
                    this.isPresentation = false
                }
            }
        })
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    checkChangeSimulation(id, arrSimulation: any[] = [], page) {
        this.arrSimulation = arrSimulation
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content'],
            title: '<b>' + this.en['alert-title'] + '</b>',
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
            modifier: 'rowfooter',
            callback: i => {
                if (i === 0) {
                    this.clientTopServices.emitChangeArrSimulation(null)
                } else if (i === 1) {
                    this.showIt = id
                    this.planClass = id
                    this.page = page
                    this.callApiArrTopClient(page)
                    this.clientTopServices.emitChangeArrSimulation(null)
                } else if (i === 2) {
                    this.showIt = id
                    this.planClass = id
                    this.page = page
                    this.callApiArrTopClient(page)
                    this.saveSimulation()
                }
            },
        })
    }

    saveSimulation() {

        const bodyCreate: any = {}
        bodyCreate['simulations'] = this.arrSimulation

        const result = '{"clientId":"' + this.idClient + '"}'
        const clientVisit: any = {}
        clientVisit[result] = true
        const map: any = {}
        map[this.idClient] = true
        const status: any = {
            client: {
                map: map,
            },
            clientVisit: {
                paths: clientVisit,
                map: map,
            },
            clinic: {
                paths: {
                    '{}': true,
                },
            },
            setting: {
                map: {
                    common: true,
                },
                paths: {
                    '{}': true,
                },
            },
            staff: {
                paths: {
                    '{"roles":"cordinator"}': true,
                    '{"roles":"doctor"}': true,
                    '{}': true,
                },
            },
        }
        const resourceData: any = {
            actions: [
                {
                    type: 'update',
                    collection: 'client',
                    id: this.idClient,
                    value: bodyCreate,
                },
            ],
            status: status,
        }

        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.clientTopServices.emitChangeArrSimulation(null)
            })
        })
    }

    getListNote() {
        this.clientTopServices.changeEmittedNote$.subscribe(arrayNoteList => {
            if (arrayNoteList) {
                if (arrayNoteList[0] === 'ModalClientDetailRegistrationComponent-arrayNoteList') {
                    this.arrNoteList = arrayNoteList[1]
                    const emitNoteList: any = {}
                    this.contentNote = this.arrNoteList
                    emitNoteList['arrayNoteList'] = this.arrNoteList
                    this.clientTopServices.emitChangeNoteList(emitNoteList)
                }
            }
        })
    }

    getArrClientTop() {
        // this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrClientTop => {
        if (this.clientTopServices.checkChangeData) {
            this.changeLanguage()
            notification.confirm({
                message: this.en['alert-content'],
                title: '<b>' + this.en['alert-discard'] + '</b>',
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                modifier: 'rowfooter',
                callback: i => {
                    if (i === 0) {
                    } else if (i === 1) {
                    } else if (i === 2) {
                        const arrClientTop: any = this.clientTopServices.returnArrAll()
                        if (arrClientTop != null && arrClientTop['registration'] != undefined) {
                            this.arrAllClientTop = arrClientTop['registration']
                            this.countArrAllClientTop = arrClientTop['registration'].length
                        }
                    }
                },
            })
        }
        return this.arrAllClientTop
        // });
    }

    writeNote() {
        // const activeDevicePage = ['ClientDetailComponent-writeNote', this.contentNote, true, this.indexNote];
        // this.clientTopServices.emitChange(activeDevicePage);
    }

    confirmNodeText() {
        this.clientTopServices.changecheckDataAfterConfirm(true)
    }


    showTextNote(data: boolean) {
        if (data === true) {
            this.showTextareaNote = 'active'
        } else {
            this.showTextareaNote = 'hidden'
        }
        this.textareaNote = !data
    }

    getDataDeleteRecorndLast() {
        this.clientTopServices.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ModalClientDetailRegistrationComponent-deleteRecorndLast') {
                        this.callApiInfoTopClient(this.idClient, '')
                    }
                }
            },
        )
    }

    getDataNoteTextAfterChangeDataRecrond() {
        this.clientTopServices.ChangeIndexToGetNoteEmittedSlider$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ModalClientDetailRegistrationComponent-valueNote' && success[1]) {
                        // this.indexNote = success[1];
                        // this.contentNote = this.arrAllClientTop[success[1]]['note'] ? this.arrAllClientTop[success[1]]['note'] : '';
                    }
                }
            },
        )
    }

    getDataNoteTextBefore() {
        this.clientTopServices.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ModalClientDetailRegistrationComponent-valueNoteBeforeOld' && success[1] && success[2]) {
                        this.contentNote = this.arrAllClientTop[success[1]]['note'] = success[2]                       
                    }
                }
            },
        )
    }

    // getDataAfterDeleteFormModal() {
    //   this.clientTopServices.changeEmitted$.subscribe(
    //     success => {
    //       if (success) {
    //         if (success[0] === 'ModalListImageTopComponent-arrayClientVisitUpdate') {
    //           if (success[1]) {
    //             const indexRecrond = success[2];
    //             if (success[3] === indexRecrond) {
    //               if (indexRecrond === 0) {
    //                 this.index = 0;
    //               } else {
    //                 this.index = indexRecrond - 1;
    //               }
    //             } else if (indexRecrond === 0) {
    //               this.index = 0;
    //             } else {
    //               this.index = success[3];
    //             }
    //             this.callApiInfoTopClient(this.idClient);
    //           }
    //         }
    //       }
    //     }
    //   );
    // }


    checkChangeRefreshData() {
        this.clientTopServices.ChangeRefreshEmittedSlider$.subscribe(res => {
            if (res != null && res[0] === 'ModalClientDetailRegistrationComponent-emitChangeRefresh') {
                if (res[1] != '') {
                    this.index = res[1]
                }
                this.callApiInfoTopClientRefresh(this.idClient)
                this.checkDatachenageLocal = res[2]
            }
        })
    }

    toggleProfile(event) {
        this.profile = (event === -1 ? 0 : -1)
        const emitUser: any = {}
        if (this.profile == 0) {
            emitUser['status'] = 'in'
            this.animationState = 'in'
        } else {
            emitUser['status'] = 'out'
            this.animationState = 'out'
        }

        this.clientTopServices.emitChangeViewDetailUser(emitUser)
    }

    changeTabName() {
        this.unscrTabName = this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
            if (infoTabName) {
                if (this.tabName != infoTabName['tabName']) {
                    this.tabName = infoTabName['tabName']
                    if (this.isLoadingChangeTabName) {
                        const newData = this.getDataChangeTabName(this.tabName)
                        this.getNewIndexWhenChangeTab(newData)
                    }
                }
            }
        })
    }

    getDataChangeTabName(tabName) {
        const arr: any[] = jQuery.extend(true, [], this.arrTmpArrClientTop)
        let isReload = false
        let arrKeys: any[] = []
        let arrSlideShow: any[] = []
        if (tabName != undefined) {
            switch (tabName) {
                case 'face-all':
                    isReload = true
                    arrKeys = ['face-1', 'face-2', 'face-3', 'face-4', 'face-5', 'face-6', 'face-all']
                    break
                case 'tooth-all':
                    isReload = true
                    arrKeys = ['tooth-right', 'tooth-left', 'tooth-front', 'tooth-upper', 'tooth-overjet', 'tooth-lower', 'tooth-all']
                    break
                case 'aligner-all':
                    isReload = true
                    arrKeys = ['aligner-right', 'aligner-left', 'aligner-front', 'aligner-upper', 'aligner-overjet', 'aligner-lower', 'aligner-all']
                    break
                case 'xp-all':
                    isReload = true
                    arrKeys = ['xp-1', 'xp-2', 'xp-3', 'xp-4', 'xp-5', 'xp-6', 'xp-all']
                    break
                case 'other-all':
                    isReload = true
                    arrKeys = ['other-1', 'other-2', 'other-3', 'other-4', 'other-5', 'other-6', 'other-all']
                    break
                case 'movie-all':
                    isReload = true
                    arrKeys = ['movie-1', 'movie-2', 'movie-3', 'movie-4', 'movie-5', 'movie-6', 'movie-all']
                    break
                case 'smile':
                    isReload = true
                    break
                case 'dsd':
                    isReload = true
                    break
                case 'dental-all':
                    isReload = true
                    break
                default:
                    isReload = false
                    break
            }
        }
        // console.log('tab name: ' + tabName);
        if (isReload == true) {
            this.countArrAllClientTop = 0
            if (arr.length > 0) {
                arr.forEach((el, i) => {
                    if (arrKeys != undefined && arrKeys.length > 0) {
                        //edit 11/3/21
                        let allFlg: boolean = false;
                        const arrAll = el[tabName]
                        if(arrAll != undefined && arrAll.length > 0){
                            arrAll.forEach(value => {
                                if (value != null && value['id'] != undefined && value['id'] != '') {
                                    allFlg = true;
                                }
                            });
                        }
                        arrKeys.forEach(key => {
                            const id: any = el['_id']
                            if (key != '_id') {
                                const arrValue: any[] = el[key]
                                if ((typeof arrValue) != 'string') {
                                    if (arrValue != undefined && arrValue.length > 0) {
                                        arrValue.forEach(value => {
                                            if (value != null && value['id'] != undefined && value['id'] != '') {
                                                const arrCheck: any = arrSlideShow.findIndex(itemCheck => {
                                                    return itemCheck['_id'] == id
                                                })
                                                if (arrCheck == -1 && allFlg) {
                                                    arrSlideShow.push(el)
                                                }
                                            }
                                        })
                                        this.countArrAllClientTop = arrSlideShow.length
                                    }
                                }
                            }
                        })
                    }
                })
            } else {
                arrSlideShow = []
                this.countArrAllClientTop = 0
            }
            if (tabName == 'dsd' || tabName == 'smile' || tabName == 'dental-all') {
                if (arr && arr.length > 0) {
                    arr.forEach((e) => {
                        if (e[tabName]) {
                            arrSlideShow.push(e)
                        }
                    })
                }
                if (arrSlideShow.length == 0 && this.nowPage != 'slideshow') {
                    arrSlideShow = arr
                }
                this.countArrAllClientTop = arrSlideShow.length
            }
        }
        this.arrAllClientTop = jQuery.extend(true, [], arrSlideShow)
        const returnData = {}
        returnData['isReload'] = isReload
        returnData['arrSlideShow'] = arrSlideShow
        return returnData
    }

    getNewIndexWhenChangeTab(dataLoadIndex) {
        let thisPage: any
        let oldArrSlideshow: any
        const arrSlideShow = dataLoadIndex['arrSlideShow'] ? jQuery.extend(true, [], dataLoadIndex['arrSlideShow']) : []
        const isReload = dataLoadIndex['isReload'] ? dataLoadIndex['isReload'] : false
        const allJsonSlideshow = this.clientTopServices.returnArrAll()
        if (allJsonSlideshow) {
            if (allJsonSlideshow['slideshow'] != undefined) {
                thisPage = 'slideshow'
                oldArrSlideshow = jQuery.extend(true, [], allJsonSlideshow['slideshow'])
            } else if (allJsonSlideshow['comparision'] != undefined) {
                thisPage = 'comparision'
                oldArrSlideshow = jQuery.extend(true, [], allJsonSlideshow['comparision'])
            } else if (allJsonSlideshow['registration'] != undefined) {
                thisPage = 'registration'
                oldArrSlideshow = jQuery.extend(true, [], allJsonSlideshow['registration'])
            }
        }

        if (isReload == true) {
            if (this.nowPage != 'registration') {
                this.countArrAllClientTop = arrSlideShow.length
                const emitArrAll: any = {}
                emitArrAll[this.nowPage] = arrSlideShow
                emitArrAll['checkChange'] = false
                emitArrAll['arrTmpArrClientTop'] = this.arrTmpArrClientTop
                if (thisPage == 'registration' && this.nowPage != thisPage) {
                    this.swapIndexSlideShow(arrSlideShow, this.arrTmpArrClientTop)
                } else if (this.page == this.nowPage && this.nowPage == thisPage) {
                    this.swapIndexSlideShow(arrSlideShow, oldArrSlideshow)
                }
                this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
            } else {
                if (thisPage != 'registration') {
                    if (this.page != thisPage) {
                        this.countArrAllClientTop = this.arrTmpArrClientTop.length
                        const emitArrAll: any = {}
                        emitArrAll[this.nowPage] = this.arrTmpArrClientTop
                        emitArrAll['checkChange'] = false
                        this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                    }
                }
            }
        }
    }

    // tách ra là 3 function riêng:
    // changeTabName(): check khi data tabName thay đổi.
    // getDataChangeTabName(): generate data khi tabName thay đổi.
    // getNewIndexWhenChangeTab: generate index and data all khi tabName thay đổi
    // (vì khi sử dụng 1 hàm này nó bị load lại nhiều lần nên khi thao tác nhiều thì dẫn đền tình trang sai index, chậm.)
    // property isLoadingChangeTabName: check xem dữ liệu đã load xong chưa(nếu chưa load xong thì không thực hiện 3 hàm trên)
    getArrSlideShow(page: any, arrAllClientTop: any[] = []) {
        let arr: any[] = jQuery.extend(true, [], this.arrTmpArrClientTop)
        let arrSlideShow: any[] = jQuery.extend(true, [], this.arrAllClientTop)
        let isReload: Boolean = false
        let thisPage: any
        let oldArrSlideshow: any
        // this.unscrUpdateData = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(allJsonSlideshow => {
        //     if (allJsonSlideshow) {
        //         if (allJsonSlideshow['slideshow'] != undefined) {
        //             thisPage = 'slideshow';
        //             oldArrSlideshow = jQuery.extend(true, [], allJsonSlideshow['slideshow']);
        //         } else if (allJsonSlideshow['comparision'] != undefined) {
        //             thisPage = 'comparision';
        //             oldArrSlideshow = jQuery.extend(true, [], allJsonSlideshow['comparision']);
        //         } else if (allJsonSlideshow['registration'] != undefined) {
        //             thisPage = 'registration';
        //             oldArrSlideshow = jQuery.extend(true, [], allJsonSlideshow['registration']);
        //         }
        //     }
        // });
        this.unscrTabName = this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
            // if (infoTabName && infoTabName['set'] && infoTabName['set'] != 'init' || infoTabName && !infoTabName['set'] ) {
            arr = jQuery.extend(true, [], this.arrTmpArrClientTop)
            isReload = false
            if (infoTabName && infoTabName['reset']) {
                arr = []
            }
            arrSlideShow = []
            const allJsonSlideshow = this.clientTopServices.returnArrAll()
            if (allJsonSlideshow) {
                if (allJsonSlideshow['slideshow'] != undefined) {
                    thisPage = 'slideshow'
                    oldArrSlideshow = jQuery.extend(true, [], allJsonSlideshow['slideshow'])
                } else if (allJsonSlideshow['comparision'] != undefined) {
                    thisPage = 'comparision'
                    oldArrSlideshow = jQuery.extend(true, [], allJsonSlideshow['comparision'])
                } else if (allJsonSlideshow['registration'] != undefined) {
                    thisPage = 'registration'
                    oldArrSlideshow = jQuery.extend(true, [], allJsonSlideshow['registration'])
                }
            }
            // if (this.tabName != infoTabName['tabName'] && nowPage == 'registration' || thisPage == nowPage && == 'slideshow') {
            if (infoTabName != undefined && infoTabName['tabName'] != undefined) {
                this.tabName = infoTabName['tabName']
                const tabName: any = infoTabName['tabName']
                let arrKeys: any[] = []
                if (tabName != undefined) {
                    switch (tabName) {
                        case 'face-all':
                            isReload = true
                            arrKeys = ['face-1', 'face-2', 'face-3', 'face-4', 'face-5', 'face-6', 'face-all']
                            break
                        case 'tooth-all':
                            isReload = true
                            arrKeys = ['tooth-right', 'tooth-left', 'tooth-front', 'tooth-upper', 'tooth-overjet', 'tooth-lower', 'tooth-all']
                            break
                        case 'aligner-all':
                            isReload = true
                            arrKeys = ['aligner-right', 'aligner-left', 'aligner-front', 'aligner-upper', 'aligner-overjet', 'aligner-lower', 'aligner-all']
                            break
                        case 'xp-all':
                            isReload = true
                            arrKeys = ['xp-1', 'xp-2', 'xp-3', 'xp-4', 'xp-5', 'xp-6', 'xp-all']
                            break
                        case 'other-all':
                            isReload = true
                            arrKeys = ['other-1', 'other-2', 'other-3', 'other-4', 'other-5', 'other-6', 'other-all']
                            break
                        case 'movie-all':
                            isReload = true
                            arrKeys = ['movie-1', 'movie-2', 'movie-3', 'movie-4', 'movie-5', 'movie-6', 'movie-all']
                            break
                        case 'smile':
                            isReload = true
                            break
                        case 'dsd':
                            isReload = true
                            break
                        case 'dental-all':
                            isReload = true
                            break
                        default:
                            isReload = false
                            break
                    }
                }
                if (isReload == true) {
                    this.countArrAllClientTop = 0
                    if (arr.length > 0) {
                        arr.forEach((el, i) => {
                            if (arrKeys != undefined && arrKeys.length > 0) {
                                arrKeys.forEach(key => {
                                    const id: any = el['_id']
                                    if (key != '_id') {
                                        const arrValue: any[] = el[key]
                                        if ((typeof arrValue) != 'string') {
                                            if (arrValue != undefined && arrValue.length > 0) {
                                                arrValue.forEach(value => {
                                                    if (value != null && value['id'] != undefined && value['id'] != '') {
                                                        const arrCheck: any = arrSlideShow.findIndex(itemCheck => {
                                                            return itemCheck['_id'] == id
                                                        })
                                                        if (arrCheck == -1) {
                                                            arrSlideShow.push(el)
                                                        }
                                                    }
                                                })
                                                this.countArrAllClientTop = arrSlideShow.length
                                            }
                                        }
                                    }
                                })
                            }
                        })
                    } else {
                        arrSlideShow = []
                        this.countArrAllClientTop = 0
                    }
                    if (tabName == 'dsd' || tabName == 'smile') {
                        if (arr && arr.length > 0) {
                            arr.forEach((e) => {
                                if (e[tabName]) {
                                    arrSlideShow.push(e)
                                }
                            })
                        }
                        if (arrSlideShow.length == 0 && this.nowPage != 'slideshow') {
                            arrSlideShow = arr
                        }
                        this.countArrAllClientTop = arrSlideShow.length
                    }
                }
            }
            if (isReload == true) {
                if (this.nowPage != 'registration') {
                    this.countArrAllClientTop = arrSlideShow.length
                    const emitArrAll: any = {}
                    emitArrAll[this.nowPage] = arrSlideShow
                    emitArrAll['checkChange'] = false
                    emitArrAll['arrTmpArrClientTop'] = this.arrTmpArrClientTop
                    if (thisPage == 'registration' && this.nowPage != thisPage) {
                        // console.log('thispage111: ', thisPage);
                        // console.log('nowpage111: ', this.nowPage);
                        // console.log('this.page111: ', this.page);
                        // console.log('arrSlideShow111: ', arrSlideShow);
                        this.swapIndexSlideShow(arrSlideShow, this.arrTmpArrClientTop)
                    } else if (this.page == this.nowPage && this.nowPage == thisPage) {
                        // console.log('thispage222: ', thisPage);
                        // console.log('nowpage222: ', this.nowPage);
                        // console.log('this.page222: ', this.page);
                        // console.log('arrSlideShow222: ', arrSlideShow);
                        // console.log('oldArrSlideshow222: ', oldArrSlideshow);
                        this.swapIndexSlideShow(arrSlideShow, oldArrSlideshow)
                    }
                    this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                } else {
                    if (thisPage != 'registration') {
                        if (this.page != thisPage) {
                            this.countArrAllClientTop = this.arrTmpArrClientTop.length
                            const emitArrAll: any = {}
                            emitArrAll[this.nowPage] = this.arrTmpArrClientTop
                            emitArrAll['checkChange'] = false
                            this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                        }
                    }
                }
            }
            // }
            // }
        })
        return arrSlideShow
    }

    swapIndexSlideShow(newArrSlideshow: any[] = [], oldArrSlideshow: any[] = []) {
        const index = this.clientTopServices.getIndex()
        if (index != null) {
            if (newArrSlideshow.length == 0) {
                const emitIndex: any = {}
                emitIndex['index'] = 0
                this.clientTopServices.emitChangeIndex(emitIndex)
            } else if (this.initIndex == 'init') {
                const emitIndex: any = {}
                emitIndex['index'] = newArrSlideshow.length - 1
                this.initIndex = ''
                this.clientTopServices.emitChangeIndex(emitIndex)
                const emitInit: any = {}
                emitInit['init'] = ''
                this.clientTopServices.emitChangeInit(emitInit)
            } else {
                const jsonOld: any = jQuery.extend(true, {}, oldArrSlideshow[index])
                if (index < oldArrSlideshow.length) {
                    const id: any = jsonOld['_id']
                    const newIndex: any = newArrSlideshow.findIndex((el, i) => {
                        return el['_id'] == id
                    })
                    if (newIndex != -1) {
                        const emitIndex: any = {}
                        emitIndex['index'] = newIndex
                        this.clientTopServices.emitChangeIndex(emitIndex)
                    } else {
                        const emitIndex: any = {}
                        const dateString: any = jsonOld['dateStringToInit']
                        const lessArr: any[] = newArrSlideshow.filter(el => {
                            return el['dateStringToInit'] < dateString
                        })
                        if (lessArr.length > 0) {
                            const lessJson: any = lessArr[lessArr.length - 1]
                            const lessIndex: any = newArrSlideshow.findIndex((el, i) => {
                                return lessJson['_id'] == el['_id']
                            })
                            if (lessIndex != -1) {
                                emitIndex['index'] = lessIndex
                                this.clientTopServices.emitChangeIndex(emitIndex)
                            } else {
                                emitIndex['index'] = 0
                                this.clientTopServices.emitChangeIndex(emitIndex)
                            }
                        } else {
                            const biggerArr: any[] = newArrSlideshow.filter(el => {
                                return el['dateStringToInit'] > dateString
                            })
                            if (biggerArr.length > 0) {
                                const biggerJson: any = biggerArr[0]
                                const biggerIndex: any = newArrSlideshow.findIndex((el, i) => {
                                    return biggerJson['_id'] == el['_id']
                                })
                                if (biggerIndex != -1) {
                                    emitIndex['index'] = biggerIndex
                                    this.clientTopServices.emitChangeIndex(emitIndex)
                                } else {
                                    emitIndex['index'] = 0
                                    this.clientTopServices.emitChangeIndex(emitIndex)
                                }
                            }
                        }
                    }
                } else {
                    const emitIndex: any = {}
                    emitIndex['index'] = 0
                    this.clientTopServices.emitChangeIndex(emitIndex)
                }
            }

        }
    }

    saveUpdateNodeText() {
        const valNodeText = this.contentNote
        const clientId = {}
        const result = this.idClient
        clientId[result] = true
        const resourceData = {
            actions: [
                {
                    collection: 'clientVisit',
                    id: result,
                    type: 'update',
                    value: {
                        note: valNodeText,
                    },
                },
            ],
            status: {
                client: {
                    map: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const ArrayValueNote = this.clientTopServices.returnArrAll()
                const arr = ArrayValueNote['registration'];
                const item = arr.findIndex(ele => 
                    {return ele.clientId == result})
                if(item != -1) ArrayValueNote['registration'][item]['note'] = valNodeText
                this.clientTopServices.emitChangeAllArrClientTop(ArrayValueNote)
                
            })
        })
    }

    onSaveRegistration(page) {
        this.isLoadingChangeTabName = false
        const bodyUpdate: any = {}
        let resourceData: any = {}
        const arrSaveClientTop: any[] = this.clientTopServices.getAllArrClientTop()
        const index = this.clientTopServices.getIndex()

        let jsonNow: any
        let id: any = ''
        const resultClientInfor = this.idClient
        const result = '{"clientId":"' + this.idClient + '"}'
        const clientVisit: any = {}
        clientVisit[result] = true
        const status: any = {
            clientVisit: {
                paths: clientVisit,
            },
            clinic: {
                paths: {
                    '{}': true,
                },
            },
            setting: {
                map: {
                    common: true,
                },
                paths: {
                    '{}': true,
                },
            },
            staff: {
                paths: {
                    '{"roles":"cordinator"}': true,
                    '{"roles":"doctor"}': true,
                    '{}': true,
                },
            },
        }
        if (arrSaveClientTop[index]) {
            jsonNow = arrSaveClientTop[index]
            if (jsonNow['_id']) {
                id = jsonNow['_id']
            }
            if (id == '') {
                bodyUpdate['clientId'] = this.idClient
            }
            bodyUpdate['face-1'] = jsonNow['face-1']
            bodyUpdate['face-2'] = jsonNow['face-2']
            bodyUpdate['face-3'] = jsonNow['face-3']
            bodyUpdate['face-4'] = jsonNow['face-4']
            bodyUpdate['face-5'] = jsonNow['face-5']
            bodyUpdate['face-6'] = jsonNow['face-6']
            bodyUpdate['face-all'] = jsonNow['face-all']

            bodyUpdate['tooth-all'] = jsonNow['tooth-all']
            bodyUpdate['tooth-right'] = jsonNow['tooth-right']
            bodyUpdate['tooth-front'] = jsonNow['tooth-front']
            bodyUpdate['tooth-left'] = jsonNow['tooth-left']
            bodyUpdate['tooth-lower'] = jsonNow['tooth-lower']
            bodyUpdate['tooth-overjet'] = jsonNow['tooth-overjet']
            bodyUpdate['tooth-upper'] = jsonNow['tooth-upper']

            bodyUpdate['aligner-all'] = jsonNow['aligner-all']
            bodyUpdate['aligner-right'] = jsonNow['aligner-right']
            bodyUpdate['aligner-front'] = jsonNow['aligner-front']
            bodyUpdate['aligner-left'] = jsonNow['aligner-left']
            bodyUpdate['aligner-lower'] = jsonNow['aligner-lower']
            bodyUpdate['aligner-overjet'] = jsonNow['aligner-overjet']
            bodyUpdate['aligner-upper'] = jsonNow['aligner-upper']

            bodyUpdate['xp-1'] = jsonNow['xp-1']
            bodyUpdate['xp-2'] = jsonNow['xp-2']
            bodyUpdate['xp-3'] = jsonNow['xp-3']
            bodyUpdate['xp-4'] = jsonNow['xp-4']
            bodyUpdate['xp-5'] = jsonNow['xp-5']
            bodyUpdate['xp-6'] = jsonNow['xp-6']
            bodyUpdate['xp-all'] = jsonNow['xp-all']

            bodyUpdate['note'] = this.contentNote

            bodyUpdate['other-1'] = jsonNow['other-1']
            bodyUpdate['other-2'] = jsonNow['other-2']
            bodyUpdate['other-3'] = jsonNow['other-3']
            bodyUpdate['other-4'] = jsonNow['other-4']
            bodyUpdate['other-5'] = jsonNow['other-5']
            bodyUpdate['other-6'] = jsonNow['other-6']
            bodyUpdate['other-all'] = jsonNow['other-all']

            bodyUpdate['movie-1'] = jsonNow['movie-1']
            bodyUpdate['movie-2'] = jsonNow['movie-2']
            bodyUpdate['movie-3'] = jsonNow['movie-3']
            bodyUpdate['movie-4'] = jsonNow['movie-4']
            bodyUpdate['movie-5'] = jsonNow['movie-5']
            bodyUpdate['movie-6'] = jsonNow['movie-6']
            bodyUpdate['movie-all'] = jsonNow['movie-all']
            bodyUpdate['dsd'] = jsonNow['dsd'] ? jsonNow['dsd'] : null
            bodyUpdate['smile'] = jsonNow['smile'] ? jsonNow['smile'] : null
            
            bodyUpdate['dental-all'] = jsonNow['dental-all'] ? jsonNow['dental-all'] : null
            if (id != '') {
                resourceData = {
                    actions: [
                        {
                            type: 'update',
                            collection: 'clientVisit',
                            id: id,
                            value: bodyUpdate,
                        },
                    ],
                    status: status,
                }
            } else {
                resourceData = {
                    actions: [
                        {
                            type: 'create',
                            collection: 'clientVisit',
                            value: bodyUpdate,
                        },
                    ],
                    status: status,
                }
            }
            const keyListnodeSave = ['ClientDetailComponent-keyListnodeSave-ModalClientDetailRegistrationComponent']
            this.clientTopServices.emitChange(keyListnodeSave)
            
            // this.saveUpdateNodeText();
            this.callApiInfoClientDetail(this.idClient, 'init');
            this.auth.authToken().then(tokenReNew => {
                this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                    this.isLoadingChangeTabName = true
                    this.clientTopServices.checkChangeData = false
                    const clientDataInfoTopclinet = this.clientInfo = success['response']['clientVisit']['paths'][result]
                    this._clientDetailServices.emitChange(clientDataInfoTopclinet)
                    this.arrTmpArrClientTop = success['response']['clientVisit']['paths']['' + result] ? success['response']['clientVisit']['paths']['' + result] : []
                    this.countArrAllClientTop = this.arrTmpArrClientTop.length
                    if (success['response']['client'] != undefined) {
                        this.arayListNote = success['response']['client']['map'][resultClientInfor]['imageSet']
                    }

                    
                    // const resetTabName = this.clientTopServices.functReturnTabName();
                    // resetTabName['set'] = 'other';
                    // this.clientTopServices.emitChangeTabName(resetTabName);
                    if (this.countArrAllClientTop > 0) {
                        this.arrTmpArrClientTop = this.clientTopServices.changeDateStringToDecoe(this.arrTmpArrClientTop)
                        this.arrTmpArrClientTop.sort((function(obj1, obj2) {
                            return parseFloat(obj1.dateStringToInit) - parseFloat(obj2.dateStringToInit)
                        }))
                        const newData = this.getDataChangeTabName(this.tabName)
                        this.getNewIndexWhenChangeTab(newData)
                    } else {
                        this.arrAllClientTop = []
                    }

                    const imageFrontSmile = this.getFrontSmileToAvatar(this.arrTmpArrClientTop)
                    if (imageFrontSmile !== undefined) {
                        if (typeof this.faceImage === 'undefined') {
                            this.callApiUpdateFaceImage(imageFrontSmile)
                        } else if (this.faceImage !== '') {
                            if (this.faceImage['id'] !== imageFrontSmile['id']) {
                                this.callApiUpdateFaceImage(imageFrontSmile)
                            } else if (imageFrontSmile['matrix'] != undefined && this.faceImage['matrix'] !== imageFrontSmile['matrix'].toString()) {
                                this.callApiUpdateFaceImage(imageFrontSmile)
                            }
                        }
                    }


                })
            })
        }
        else return
    }

    getFrontSmileToAvatar(arrImageClientTop) {
        const arrImageClientTopFrontSmile = arrImageClientTop
        for (let i = arrImageClientTopFrontSmile.length - 1; i >= 0; i--) {
            if (arrImageClientTopFrontSmile[i]['face-1'] != undefined && arrImageClientTopFrontSmile[i]['face-1'].length > 0 && arrImageClientTopFrontSmile[i]['face-1'][0]['id'] !== '') {
                return arrImageClientTopFrontSmile[i]['face-1'][0]
            } else if (i == 0) {
                return arrImageClientTopFrontSmile[i]['face-1'][0]
            }
        }
    }
    callApiUpdateFaceImage(imageFace) {
        console.log('call API update image 1191')
        const clientId = {}
        const result = this.idClient
        clientId[result] = true
        const resourceData = this.restApi.makeResourceObject({
            actions: [
                {
                    collection: 'client',
                    id: this.idClient,
                    type: 'update',
                    value: {
                        faceImage: imageFace,
                    },
                },
            ],
            status: {
                client: {
                    map: clientId,
                },
            },
        })
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.faceImage = success['response']['client']['map'][result]['faceImage']
                const imageFaceClient = ['ModalClientDetailRegistrationComponent-imageFaceClient', success['response']['client']['map'][result]['faceImage']]
                this._sharedService.emitChangeImageFace(imageFaceClient)
            })
        })
    }


    // convert image base64 to image file
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
    }

    uploadDSD(tabId) {
        let index = this.clientTopServices.getIndex()
        this.arrTmpArrClientTop = this.clientTopServices.getAllArrClientTop()
        document.getElementById('save-canvas-btn').click()
        const canvas = window['canvasSave']
        if (canvas && canvas != 'undefined') {
            this.clientTopServices.canvasModalLoading$.next({ show: true, status: 'save' })
            let sendImgs = {}
            let hasImg = window['canvasImgBaseSave'] && window['canvasImgBaseSave'] != 'undefined'
            if (this.tabName == 'dsd' && hasImg) {
                const imgBaseFile = this.dataURLtoFile(window['canvasImgBaseSave'], 'canvasImgBase')
                const imgBeforeFile = this.dataURLtoFile(window['canvasImgBeforeSave'], 'canvasImgBefore')
                const imgDemoFile = this.dataURLtoFile(window['canvasImgDemoSave'], 'canvasImgDemo')
                sendImgs = {
                    imgBase: imgBaseFile,
                    imgBefore: imgBeforeFile,
                    imgDemo: imgDemoFile,
                }
            } else if (this.tabName == 'dsd' && !hasImg) {
                const imgDemoFile = this.dataURLtoFile(window['canvasImgDemoSave'], 'canvasImgDemo')
                sendImgs = {
                    imgDemo: imgDemoFile,
                }
            } else if (this.tabName == 'smile' && hasImg) {
                const imgBaseFile = this.dataURLtoFile(window['canvasImgBaseSave'], 'canvasImgBase')
                const imgDemoFile = this.dataURLtoFile(window['canvasImgDemoSave'], 'canvasImgDemo')
                sendImgs = {
                    imgBase: imgBaseFile,
                    imgDemo: imgDemoFile,
                }
            }
            this.auth.authToken().then(tokenReNew => {
                this.restApi.postCanvasImgs('image/create/', sendImgs, tokenReNew, this.tabName).subscribe(
                    data => {
                        if (this.tabName == 'dsd') {
                            if (hasImg) {
                                this.arrTmpArrClientTop[index]['dsd'] = {
                                    canvas: canvas,
                                    canvasImgBase: data[0].hash,
                                    canvasImgDemo: data[1].hash,
                                    canvasImgBefore: data[2].hash,
                                }
                            } else {
                                this.arrTmpArrClientTop[index]['dsd'] = {
                                    canvas: canvas,
                                    canvasImgBase: '',
                                    canvasImgDemo: data[0].hash,
                                    canvasImgBefore: '',
                                }
                            }
                            let canvasVideo = window['canvasVideoSave']
                            if (canvasVideo && canvasVideo != 'undefined') {
                                const part1 = canvasVideo.split('?AWSAccessKeyId')[0]
                                const part1Arr = part1.split('/')
                                this.arrTmpArrClientTop[index]['dsd'].canvasVideo = part1Arr[part1Arr.length - 1]
                            }
                        } else {
                            this.arrTmpArrClientTop[index]['smile'] = {
                                canvas: canvas,
                                canvasImgBase: data[0].hash,
                                canvasImgDemo: data[1].hash,
                            }
                        }
                        window['canvasSave'] = ''
                        window['canvasImgBaseSave'] = ''
                        window['canvasImgBeforeSave'] = ''
                        window['canvasImgDemoSave'] = ''
                        window['canvasVideoSave'] = ''
                        this.clientTopServices.changeActiveDatepickerAfterConfirm(false)
                        this.clientTopServices.changecheckDataAfterConfirm(false)
                        let emitArrAll = {}
                        emitArrAll['checkChange'] = false
                        emitArrAll['arrTmpArrClientTop'] = this.arrTmpArrClientTop
                        this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                        window['canvasChange'] = false
                        this.showIt = tabId
                        this.planClass = tabId
                        this.page = 'slideshow'
                        this.clientTopServices.emitChangePage(this.page)
                        this.onSaveRegistration(this.page)
                    }, error => {
                        this.clientTopServices.canvasModalLoading$.next({ show: false, status: 'save' })
                    },
                )
            })
        }
    }

    swapIndexRegisAndSlide(page, arrAllClientTop: any[] = [], arrRegistration: any[] = []) {
        const index: any = this.clientTopServices.getIndex()
        if (page == 'slideshow') {
            const tmpIndex: any = jQuery.extend(true, {}, arrRegistration[index])
            if (index < arrRegistration.length) {
                const dateString: any = tmpIndex['dateStringToInit']
                const id: any = tmpIndex['_id']
                const findIndexSlideShow: any = arrAllClientTop.findIndex(el => {
                    return el['_id'] == id
                })
                if (findIndexSlideShow != -1) {
                    const emitIndex: any = {}
                    emitIndex['index'] = findIndexSlideShow
                    this.clientTopServices.emitChangeIndex(emitIndex)
                } else {
                    const lessArr: any[] = arrAllClientTop.filter(el => {
                        return el['dateStringToInit'] < dateString
                    })
                    if (lessArr.length > 0) {
                        const jsonElement: any = lessArr[lessArr.length - 1]
                        const jsonIndex: any = arrAllClientTop.findIndex(el => {
                            return el['_id'] == jsonElement['_id']
                        })
                        const emitIndex: any = {}
                        if (jsonIndex != -1) {
                            emitIndex['index'] = jsonIndex
                        } else {
                            emitIndex['index'] = 0
                        }
                        this.clientTopServices.emitChangeIndex(emitIndex)
                    } else {
                        const thanArr: any[] = arrAllClientTop.filter(el => {
                            return el['dateStringToInit'] > dateString
                        })
                        if (thanArr.length > 0) {
                            const jsonElement = thanArr[0]
                            const jsonIndex: any = arrAllClientTop.findIndex(el => {
                                return jsonElement['_id'] == el['_id']
                            })
                            const emitIndex: any = {}
                            if (jsonIndex != -1) {
                                emitIndex['index'] = jsonIndex
                            } else {
                                emitIndex['index'] = 0
                            }
                            this.clientTopServices.emitChangeIndex(emitIndex)
                        }
                    }
                }
            } else {
                const emitIndex: any = {}
                emitIndex['index'] = 0
                this.clientTopServices.emitChangeIndex(emitIndex)
            }
        } else if (page == 'registration') {
            const tmpIndex: any = jQuery.extend(true, {}, arrAllClientTop[index])
            if (index < arrAllClientTop.length) {
                const id: any = tmpIndex['_id']
                const findIndexRegistration: any = arrRegistration.findIndex((el, i) => {
                    return el['_id'] == id
                })
                if (findIndexRegistration != -1) {
                    const emitIndex: any = {}
                    emitIndex['index'] = findIndexRegistration
                    emitIndex['updateIndex'] = true
                    emitIndex['oldIndex'] = 0
                    this.clientTopServices.emitChangeIndex(emitIndex)
                } else {
                    const emitIndex: any = {}
                    emitIndex['index'] = 0
                    this.clientTopServices.emitChangeIndex(emitIndex)
                }
            } else {
                const emitIndex: any = {}
                emitIndex['index'] = 0
                this.clientTopServices.emitChangeIndex(emitIndex)
            }
        }
    }

    toggleTabItem(id, option, event) {
        event.preventDefault()
        this.getListNote()
        this.clientTopServices.emitChangeSlider(null)
        this.stateServices.emitChangeHash(null)
        this.clientTopServices.emitChangeIsCreated(null)
        // this.clientTopServices.emitChangeArrCopy(null);
        this.clientTopServices.emitChangeStyle(null)
        const emitArrAll: any = {}
        const emitNoteList: any = {}
        // this.tabName = this.clientTopServices.getTabName();
        switch (option) {
            case 'option_0':
                const simulation: any = this.clientTopServices.returnArrSimulation()
                if (simulation != null && simulation['simulation'] != undefined) {
                    this.checkChangeSimulation(id, simulation['simulation'], 'registration')
                } else {
                    this.showIt = id
                    this.planClass = id
                    this.page = 'registration'
                    this.clientTopServices.emitChangePage(this.page)
                    this.callApiArrTopClient(this.page)
                    emitNoteList['arrayNoteList'] = this.arrNoteList
                    this.clientTopServices.emitChangeNoteList(emitNoteList)
                    this.clientTopServices.checkChangeData = false
                }
                break
            case 'option_1':
                if (window['canvasChange']) {
                    this.clientTopServices.checkChangeData = true
                }
                this.clientTopServices.slideshowActive = true
                if (this.clientTopServices.checkChangeData === true) {
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content'],
                        title: '<b>' + this.en['alert-title'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i === 0) {
                            } else if (i === 1) {
                                this.showIt = id
                                this.planClass = id
                                this.page = 'slideshow'
                                // this.arrAllClientTop = this.getArrClientTop();
                                this.clientTopServices.emitChangePage(this.page)
                                this.callApiArrTopClient(this.page)
                                emitNoteList['arrayNoteList'] = this.arrNoteList
                                this.clientTopServices.emitChangeNoteList(emitNoteList)
                                this.clientTopServices.checkChangeData = false
                            } else if (i === 2) {
                                if (this.tabName != 'dsd' && this.tabName != 'smile') {
                                    this.showIt = id
                                    this.planClass = id
                                    this.page = 'slideshow'
                                    this.clientTopServices.emitChangePage(this.page)
                                    this.onSaveRegistration(this.page)
                                } else {
                                    this.uploadDSD(id)
                                }
                                this.clientTopServices.checkChangeData = false
                                emitNoteList['arrayNoteList'] = this.arrNoteList
                                this.clientTopServices.emitChangeNoteList(emitNoteList)
                            }
                        },
                    })
                } else {
                    const simulation1: any = this.clientTopServices.returnArrSimulation()
                    if (simulation1 != null && simulation1['simulation'] != undefined) {
                        this.checkChangeSimulation(id, simulation1['simulation'], 'slideshow')
                    } else {
                        this.showIt = id
                        this.planClass = id
                        this.page = 'slideshow'
                        this.clientTopServices.emitChangePage(this.page)
                        this.callApiArrTopClient(this.page)
                        emitNoteList['arrayNoteList'] = this.arrNoteList
                        // emitNoteList['arrTmpArrClientTop'] = this.arrTmpArrClientTop;
                        this.clientTopServices.emitChangeNoteList(emitNoteList)
                        this.clientTopServices.checkChangeData = false
                    }
                }
                break
            case 'option_2':
                if (window['canvasChange']) {
                    this.clientTopServices.checkChangeData = true
                }
                if (this.clientTopServices.checkChangeData === true) {
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content'],
                        title: '<b>' + this.en['alert-title'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i === 0) {
                            } else if (i === 1) {
                                this.showIt = id
                                this.planClass = id
                                this.page = 'comparision'
                                this.clientTopServices.emitChangePage(this.page)
                                this.showTextareaNote = 'hidden'
                                this.callApiArrTopClient(this.page)
                                this.clientTopServices.checkChangeData = false
                            } else if (i === 2) {
                                this.showIt = id
                                this.planClass = id
                                this.page = 'comparision'
                                this.clientTopServices.emitChangePage(this.page)
                                this.onSaveRegistration(this.page)
                                this.clientTopServices.checkChangeData = false
                            }
                        },
                    })
                } else {
                    const simulation1: any = this.clientTopServices.returnArrSimulation()
                    if (simulation1 != null && simulation1['simulation'] != undefined) {
                        this.checkChangeSimulation(id, simulation1['simulation'], 'comparision')
                    } else {
                        this.showIt = id
                        this.planClass = id
                        this.page = 'comparision'
                        this.clientTopServices.emitChangePage(this.page)
                        this.callApiArrTopClient(this.page)
                        this.showTextareaNote = 'hidden'
                        this.clientTopServices.checkChangeData = false
                    }
                }
                break
            case 'option_3':
                if (window['canvasChange']) {
                    this.clientTopServices.checkChangeData = true
                }
                if (this.clientTopServices.checkChangeData === true) {
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content'],
                        title: '<b>' + this.en['alert-title'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], this.en['alert-discard'], this.en['alert-save']],
                        modifier: 'rowfooter',
                        callback: i => {
                            if (i === 0) {
                            } else if (i === 1) {
                                this.showIt = id
                                this.planClass = id
                                this.page = 'simulation'
                                this.clientTopServices.emitChangePage(this.page)
                                // this.arrAllClientTop = this.getArrClientTop();
                                this.showTextareaNote = 'hidden'
                                this.callApiArrTopClient(this.page)
                                this.clientTopServices.checkChangeData = false
                            } else if (i === 2) {
                                this.showIt = id
                                this.planClass = id
                                this.page = 'simulation'
                                this.clientTopServices.emitChangePage(this.page)
                                this.onSaveRegistration(this.page)
                                this.clientTopServices.checkChangeData = false
                            }
                        },
                    })
                } else {
                    this.showIt = id
                    this.planClass = id
                    this.page = 'simulation'
                    const arrClientTop: any = this.clientTopServices.returnArrAll()
                    if (arrClientTop != null && arrClientTop['registration'] != undefined) {
                        this.clientTopServices.emitChangePage(this.page)
                        this.arrTmpArrClientTop = arrClientTop['registration']
                        const newData = this.getDataChangeTabName(this.tabName)
                        this.getNewIndexWhenChangeTab(newData)
                        this.countArrAllClientTop = arrClientTop['registration'].length
                        this.swapIndexRegisAndSlide(this.page, this.arrAllClientTop, this.arrTmpArrClientTop)
                        this.showTextareaNote = 'hidden'
                        this.clientTopServices.checkChangeData = false
                    }
                }
                break
            default:
                break
        }
    }

    showLink() {
        const clientInfoUrl = this.clientInfoUrl
        const arrayClientInfoUrl = []
        for (let j = 0; j < clientInfoUrl.length; j++) {
            arrayClientInfoUrl.push(
                {
                    label: clientInfoUrl[j]['title'],
                },
            )
        }
        const labelCancel = { label: 'Cancel', icon: 'md-close' }
        arrayClientInfoUrl.push(labelCancel)
        openActionSheet({
            title: 'Open URL',
            cancelable: true,
            buttons: arrayClientInfoUrl,
            callback: i => {
                for (let k = 0; k < clientInfoUrl.length; k++) {
                    if (i === k) {
                        window.open(clientInfoUrl[k]['url'])
                    }
                }
            },
        })
    }

    getDoctor(success, result) {
        const listDoctor = success['response']['staff']['paths']['{"roles":"doctor"}']
        let idDoctor: any
        if (success['response']['client'] != undefined) {
            idDoctor = success['response']['client']['map'][result]['doctor']
        }
        for (let j = 0; j < listDoctor.length; j++) {
            if (idDoctor === listDoctor[j]['_id']) {
                return listDoctor[j]
            }
        }
    }

    getNameDoctor(success, result) {
        const doctor = this.getDoctor(success, result)
        if (doctor) {
            if (doctor['firstName'] && doctor['familyName']) {
                return doctor['firstName'] + doctor['familyName']
            } else {
                return doctor['firstName']
            }
        }
    }

    getClinic(success, result) {
        const listClinic = success['response']['clinic']['paths']['{}']
        let idClinic: any
        if (success['response']['client'] != undefined) {
            idClinic = success['response']['client']['map'][result]['clinic']
        }
        for (let j = 0; j < listClinic.length; j++) {
            if (idClinic === listClinic[j]['_id']) {
                return listClinic[j]
            }
        }
    }

    getNameClinic(success, result) {
        const clinic = this.getClinic(success, result)
        if (clinic) {
            if (clinic['name']) {
                return clinic['name']
            }
        }
    }

    getAge(birthday) {
        const offsetTimezone = new Date().getTimezoneOffset()
        const addTime = 24 + (offsetTimezone / 60)
        const age = moment().startOf('day').diff(moment(birthday).add(addTime, 'hours'), 'years')
        return age
    };


    getCordinator(success, result) {
        const listConrdinator = success['response']['staff']['paths']['{"roles":"cordinator"}']
        const idConrdinator = success['response']['client']['map'][result]['cordinator']
        for (let j = 0; j < listConrdinator.length; j++) {
            if (idConrdinator === listConrdinator[j]['_id']) {
                return listConrdinator[j]
            }
        }
    }

    getNameCordinator(success, result) {
        const conrdinator = this.getCordinator(success, result)
        if (conrdinator) {
            if (conrdinator['firstName'] && conrdinator['familyName']) {
                return conrdinator['firstName'] + conrdinator['familyName']
            } else {
                return conrdinator['firstName']
            }
        }
    }

    getWearingTime(success, result) {
        if (success['response']['client']['map'][result]['alignerParam']) {
            if (success['response']['client']['map'][result]['alignerParam']['wearingTime']) {
                const WearingTime = success['response']['client']['map'][result]['alignerParam']['wearingTime']
                return WearingTime
            }
        }

    };

    fullPosisinScreen(event) {
        const emit: any = {}
        this.PosisinScreen = (event === -1 ? 0 : -1)
        if (this.PosisinScreen == 0) {
            this.hiddenWhenFullscreen = 'hidden'
            emit['status'] = 'hidden'
            this._sharedService.emitChange('fullPosisinScreenHidden')
            this.clientTopServices.emitChange(emit)
        } else {
            this.hiddenWhenFullscreen = 'active'
            emit['status'] = 'active'
            this._sharedService.emitChange('fullPosisinScreenActive')
            this.clientTopServices.emitChange(emit)
        }
    }

    createArrAllClientTop() {
        const bodyCreate: any = {}
        bodyCreate['face-1'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['face-2'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['face-3'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['face-4'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['face-5'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['face-6'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['face-all'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        bodyCreate['tooth-all'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['tooth-right'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['tooth-front'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['tooth-left'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['tooth-lower'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['tooth-overjet'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['tooth-upper'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        bodyCreate['aligner-all'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['aligner-right'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['aligner-front'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['aligner-left'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['aligner-lower'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['aligner-overjet'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['aligner-upper'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        bodyCreate['xp-1'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['xp-2'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['xp-3'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['xp-4'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['xp-5'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['xp-6'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['xp-all'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        bodyCreate['other-1'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['other-2'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['other-3'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['other-4'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['other-5'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['other-6'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['other-all'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        bodyCreate['movie-1'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['movie-2'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['movie-3'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['movie-4'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['movie-5'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['movie-6'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        bodyCreate['movie-all'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        bodyCreate['dental-all'] = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },
        { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' },
        { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        const arr = [
            bodyCreate,
        ]
        return arr
    }

    callApiInfoClient(idClient) {
        const clientId = {}
        const result = idClient
        clientId[result] = true
        const resourceDataAccessLog = {
            actions: [],
            status: {
                client: {
                    map: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {
                    let clientInfoRespon: any
                    if (success['response']['client'] != undefined) {
                        clientInfoRespon = this.clientInfo = success['response']['client']['map'][result]
                        this.presentationName = this.clientInfo['presentationName']
                        this.accountDate = this.clientInfo['accountDate']
                        this.firstDate = this.clientInfo['startDate']
                        this.lastDate = this.clientInfo['lastDate']
                        this.birthday = this.clientInfo['birthday']
                    }
                    this.nameDoctor = this.getNameDoctor(success, result)
                    this.nameClinic = this.getNameClinic(success, result)
                    this.cordinator = this.getNameCordinator(success, result)
                    this.wearingTime = this.getWearingTime(success, result)

                    if (this.birthday) {
                        this.showAge = this.getAge(this.birthday)
                    } else {
                        this.showAge = 0
                    }
                    this.operator = ''
                    if (clientInfoRespon.familyName) {
                        this.operator = clientInfoRespon.familyName + ' '
                    }
                    if (clientInfoRespon.firstName) {
                        this.operator += clientInfoRespon.firstName
                    }
                    clientInfoRespon.firstName = this.operator
                    if (success['response']['client']['map'][result]['accelationDevice']) {
                        this.accelationDevice = success['response']['client']['map'][result]['accelationDevice']
                    }
                    if (success['response']['client']['map'][result]['alignerParam']) {
                        if (success['response']['client']['map'][result]['alignerParam']['day']) {
                            this.alignerParamDay = success['response']['client']['map'][result]['alignerParam']['day']
                        } else if (success['response']['client']['map'][result]['alignerParam']['interval']) {
                            this.alignerInterval = success['response']['client']['map'][result]['alignerParam']['interval']
                        }
                        if (success['response']['client']['map'][result]['alignerParam']['count']) {
                            this.alignerCount = success['response']['client']['map'][result]['alignerParam']['count']
                        }
                        if (success['response']['client']['map'][result]['alignerParam']['all']) {
                            this.alignerAll = success['response']['client']['map'][result]['alignerParam']['all']
                        }
                        this.updateActiveTitle(success['response']['client']['map'][result]['alignerParam'])
                    }
                    if (clientInfoRespon['faceImage']) {
                        const clientFaceImage = ['ClientDetailComponent-clientFaceImage', clientInfoRespon['faceImage']]
                        this.faceImage = clientInfoRespon['faceImage']
                        this.clientTopServices.emitGetFaceImage(clientFaceImage)
                    } else {
                        const clientFaceImage = ['ClientDetailComponent-clientFaceImage', '']
                        this.clientTopServices.emitGetFaceImage(clientFaceImage)
                    }

                    this.clientInfoUrl = success['response']['client']['map'][result]['relatedUrls']
                    this.showClinCheck = this.clientInfoUrl && this.clientInfoUrl.filter(x => x.title != '' && x.url != '').length > 0
                    const clientInfoUrlChange = ['ClientDetailComponent-clientInfoUrl', this.clientInfoUrl]
                    this.clientTopServices.emitChangeInfoUrlChange(clientInfoUrlChange)
                    this.arrNoteList = this.clientInfo['imageSet']
                    const emitNoteList: any = {}
                    emitNoteList['arrayNoteList'] = this.arrNoteList
                    this.clientTopServices.emitChangeNoteList(emitNoteList)
                },
            )
        })
    }

    updateActiveTitle(alignerParam) {
        if (alignerParam) {
            const phase = this.convertPhaseName(alignerParam['phase'])
            const title = alignerParam['title'] || ''
            let fullTitle = phase + ' ' + title
            fullTitle = fullTitle.trim()
            if (phase || title) {
                this.alignerTitle = '(' + fullTitle + ')'
            } else {
                this.alignerTitle = ''
            }
        }
    }

    convertPhaseName(phase) {
        if (this.phaseByName[phase]) {
            return this.phaseByName[phase].name
        } else if (this.phaseNumber[phase]) {
            return this.phaseNumber[phase - 1].name
        }
        return ''
    }


    callApiInfoTopClient(idClient, initIndex) {
        this.isLoadingChangeTabName = false
        const clientIdVisit = {}
        const result = '{"clientId":"' + this.idClient + '"}'
        clientIdVisit[result] = true
        const clientInfor = {}
        const resultClientInfor = idClient
        clientInfor[resultClientInfor] = true
        const resourceDataInfoTopclinet = {
            actions: [],
            status: {
                client: {
                    map: clientInfor,
                },
                clientVisit: {
                    paths: clientIdVisit,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataInfoTopclinet, tokenReNew).subscribe(
                success => {
                    this.isLoadingChangeTabName = true
                    const clientDataInfoTopclinet = this.clientInfo = success['response']['clientVisit']['paths'][result]
                    this._clientDetailServices.emitChange(clientDataInfoTopclinet)
                    this.arrTmpArrClientTop = success['response']['clientVisit']['paths']['' + result]
                    this.countArrAllClientTop = success['response']['clientVisit']['paths']['' + result].length
                    if (success['response']['client'] != undefined) {
                        this.arayListNote = success['response']['client']['map'][resultClientInfor]['imageSet']
                    }
                    if (this.countArrAllClientTop > 0) {
                        this.arrTmpArrClientTop = this.clientTopServices.changeDateStringToDecoe(this.arrTmpArrClientTop)
                        this.arrTmpArrClientTop.sort((function(obj1, obj2) {
                            return parseFloat(obj1['dateStringToInit']) - parseFloat(obj2['dateStringToInit'])
                        }))
                        const newData = this.getDataChangeTabName(this.tabName)
                        this.getNewIndexWhenChangeTab(newData)
                        // this.arrAllClientTop.sort((function (obj1, obj2) {
                        //   return parseFloat(obj1['dateStringToInit']) - parseFloat(obj2['dateStringToInit']);
                        // }));
                        const emitIndex: any = {}
                        if (initIndex == 'init') {
                            const index: any = this.countArrAllClientTop - 1
                            emitIndex['index'] = index
                        } else {
                            emitIndex['index'] = this.index
                        }
                        this.clientTopServices.emitChangeIndex(emitIndex)
                    } else {
                        const emitIndex: any = {}
                        emitIndex['index'] = 0
                        this.clientTopServices.emitChangeIndex(emitIndex)
                    }
                    // this.swapIndexRegisAndSlide(this.page, this.arrAllClientTop, this.arrTmpArrClientTop);
                    // this.tabName = 'tooth-all';
                    // this.emitTabName['tabName'] = this.tabName;
                    // this.clientTopServices.emitChangeTabName(this.emitTabName);
                    // const resetTabName = this.clientTopServices.functReturnTabName();
                    // resetTabName['tabName'] = this.tabName;
                    // resetTabName['set'] = 'other';
                    // this.clientTopServices.emitChangeTabName(resetTabName);
                },
            )
        })
    }

    callApiInfoClientDetail(idClient, initIndex) {
        this.isLoadingChangeTabName = false;
        const clientIdVisit = {};
        const result = '{"clientId":"' + this.idClient + '"}';
        clientIdVisit[result] = true;
        const clientInfor = {};
        const resultClientInfor = idClient;
        clientInfor[resultClientInfor] = true;
        
        let searches = {};
        let strkeySearch = `{"clientId":"${ this.idClient }"}`
        searches[strkeySearch] = true
        const resourceDataInfoClient = {
            actions: [],
            status: {
                client: {
                    map: clientInfor
                },
                clientVisit: {
                    paths: clientIdVisit
                },
                clientAligner: {
                    searches,
                },
                clinic: {
                    paths: {
                        '{}': true
                    }
                },
                setting: {
                    map: {
                        common: true
                    },
                    paths: {
                        '{}': true
                    }
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true
                    }
                }
            }
        };

        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataInfoClient, tokenReNew).subscribe(
                success => {
                    let clientInfoRespon: any;
                    if (success['response']['client'] != undefined) {
                        clientInfoRespon = this.clientInfo = success['response']['client']['map'][resultClientInfor];
                        this.presentationName = this.clientInfo['presentationName'];
                        this.accountDate = this.clientInfo['accountDate'];
                        this.firstDate = this.clientInfo['startDate'];
                        this.lastDate = this.clientInfo['lastDate'];
                        this.birthday = this.clientInfo['birthday'];
                    }
                    this.nameDoctor = this.getNameDoctor(success, resultClientInfor);
                    this.nameClinic = this.getNameClinic(success, resultClientInfor);
                    this.cordinator = this.getNameCordinator(success, resultClientInfor);
                    this.wearingTime = this.getWearingTime(success, resultClientInfor);

                    if (this.birthday) {
                        this.showAge = this.getAge(this.birthday);
                    } else {
                        this.showAge = 0;
                    }
                    this.operator = '';
                    if (clientInfoRespon.familyName) {
                        this.operator = clientInfoRespon.familyName + ' ';
                    }
                    if (clientInfoRespon.firstName) {
                        this.operator += clientInfoRespon.firstName;
                    }
                    clientInfoRespon.firstName = this.operator;
                    if (success['response']['client']['map'][resultClientInfor]['accelationDevice']) {
                        this.accelationDevice = success['response']['client']['map'][resultClientInfor]['accelationDevice'];
                    }
                    if (success['response']['client']['map'][resultClientInfor]['alignerParam']) {
                        if (success['response']['client']['map'][resultClientInfor]['alignerParam']['day']) {
                            this.alignerParamDay = success['response']['client']['map'][resultClientInfor]['alignerParam']['day'];
                        } else if (success['response']['client']['map'][resultClientInfor]['alignerParam']['interval']) {
                            this.alignerInterval = success['response']['client']['map'][resultClientInfor]['alignerParam']['interval'];
                        }
                        if (success['response']['client']['map'][resultClientInfor]['alignerParam']['count']) {
                            let listAligner = success['response']['clientAligner']['searches'][strkeySearch]
                            let activeAligner = success['response']['client']['map'][resultClientInfor]['activeAligner']
                            this.alignerCount = this.checkActiveAligner(activeAligner, listAligner)
                        }
                        if (success['response']['client']['map'][resultClientInfor]['alignerParam']['all']) {
                            this.alignerAll = success['response']['client']['map'][resultClientInfor]['alignerParam']['all'];
                        }
                        this.updateActiveTitle(success['response']['client']['map'][resultClientInfor]['alignerParam']);
                    }
                    if (clientInfoRespon['faceImage']) {
                        const clientFaceImage = ['ClientDetailComponent-clientFaceImage', clientInfoRespon['faceImage']];
                        this.faceImage = clientInfoRespon['faceImage']
                        this.clientTopServices.emitGetFaceImage(clientFaceImage);
                    } else {
                        const clientFaceImage = ['ClientDetailComponent-clientFaceImage', ''];
                        this.clientTopServices.emitGetFaceImage(clientFaceImage);
                    }
                    //top client
                    this.isLoadingChangeTabName = true;
                    const clientDataInfoTopclinet = this.clientInfo = success['response']['clientVisit']['paths'][result];
                    this._clientDetailServices.emitChange(clientDataInfoTopclinet);
                    this.arrTmpArrClientTop = success['response']['clientVisit']['paths']['' + result];
                    this.countArrAllClientTop = success['response']['clientVisit']['paths']['' + result].length;
                    if (success['response']['client'] != undefined) {
                        this.arayListNote = success['response']['client']['map'][resultClientInfor]['imageSet'];
                    }
                    if (this.countArrAllClientTop > 0) {
                        this.arrTmpArrClientTop = this.clientTopServices.changeDateStringToDecoe(this.arrTmpArrClientTop);
                        this.arrTmpArrClientTop.sort((function (obj1, obj2) {
                            return parseFloat(obj1['dateStringToInit']) - parseFloat(obj2['dateStringToInit']);
                        }));
                        const newData = this.getDataChangeTabName(this.tabName);
                        this.getNewIndexWhenChangeTab(newData);
                        const emitIndex: any = {};
                        if (initIndex == 'init') {
                            const index: any = this.countArrAllClientTop - 1;
                            emitIndex['index'] = index;
                        } else {
                            emitIndex['index'] = this.index;
                        }
                        this.clientTopServices.emitChangeIndex(emitIndex);
                    } else {
                        const emitIndex: any = {};
                        emitIndex['index'] = 0;
                        this.clientTopServices.emitChangeIndex(emitIndex);
                    }
                    //end
                    this.clientInfoUrl = success['response']['client']['map'][resultClientInfor]['relatedUrls'];
                    this.showClinCheck = this.clientInfoUrl && this.clientInfoUrl.filter(x => x.title != "" && x.url != "").length > 0;
                    const clientInfoUrlChange = ['ClientDetailComponent-clientInfoUrl', this.clientInfoUrl];
                    this.clientTopServices.emitChangeInfoUrlChange(clientInfoUrlChange);
                    this.arrNoteList = this.clientInfo['imageSet'];
                    const emitNoteList: any = {};
                    emitNoteList['arrayNoteList'] = this.arrNoteList;
                    this.clientTopServices.emitChangeNoteList(emitNoteList);
                }
            );
        });
    }

    callApiInfoTopClientRefresh(idClient) {
        const clientIdVisit = {}
        const result = '{"clientId":"' + this.idClient + '"}'
        clientIdVisit[result] = true
        const clientInfor = {}
        const resultClientInfor = idClient
        clientInfor[resultClientInfor] = true
        const resourceDataInfoTopclinet = {
            actions: [],
            status: {
                client: {
                    map: clientInfor,
                },
                clientVisit: {
                    paths: clientIdVisit,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataInfoTopclinet, tokenReNew).subscribe(
                success => {
                    const clientDataInfoTopclinet = this.clientInfo = success['response']['clientVisit']['paths'][result]
                    this._clientDetailServices.emitChange(clientDataInfoTopclinet)
                    this.arrTmpArrClientTop = success['response']['clientVisit']['paths']['' + result]
                    this.countArrAllClientTop = success['response']['clientVisit']['paths']['' + result].length
                    this.arayListNote = success['response']['client']['map'][resultClientInfor]['imageSet']
                    if (this.countArrAllClientTop > 0) {
                        this.arrTmpArrClientTop = this.clientTopServices.changeDateStringToDecoe(this.arrTmpArrClientTop)
                        this.arrTmpArrClientTop.sort((function(obj1, obj2) {
                            return parseFloat(obj1.dateStringToInit) - parseFloat(obj2.dateStringToInit)
                        }))
                        const emitArrAll: any = {}
                        emitArrAll[this.page] = this.arrTmpArrClientTop
                        emitArrAll['checkChange'] = false
                        this.clientTopServices.emitChangeAllArrClientTop(emitArrAll)
                        const newData = this.getDataChangeTabName(this.tabName)
                        this.getNewIndexWhenChangeTab(newData)

                        this.arrAllClientTop.sort((function(obj1, obj2) {
                            return parseFloat(obj1.dateStringToInit) - parseFloat(obj2.dateStringToInit)
                        }))
                    }
                },
            )
        })
    }

    callApiArrTopClient(page) {
        this.isLoadingChangeTabName = false
        const clientIdVisit = {}
        const result = '{"clientId":"' + this.idClient + '"}'
        const resultSetting = '{}'
        clientIdVisit[result] = true
        const clientInfor = {}
        const resultClientInfor = this.idClient
        clientInfor[resultClientInfor] = true
        const resourceDataInfoTopclinet = {
            actions: [],
            status: {
                client: {
                    map: clientInfor,
                },
                clientVisit: {
                    paths: clientIdVisit,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.auth.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataInfoTopclinet, tokenReNew).subscribe(
                success => {
                    this.isLoadingChangeTabName = true
                    const clientDataInfoTopclinet = this.clientInfo = success['response']['clientVisit']['paths'][result]
                    const clientDataInfoTopSetting = this.clientInfo = success['response']['setting']['paths'][resultSetting];
                    this.clientTopServices.emitSettingData(clientDataInfoTopSetting);
                    this._clientDetailServices.emitChange(clientDataInfoTopclinet)
                    this.arrTmpArrClientTop = success['response']['clientVisit']['paths']['' + result]
                    this.countArrAllClientTop = this.arrTmpArrClientTop.length
                    if (success['response']['client'] != undefined) {
                        this.arayListNote = success['response']['client']['map'][resultClientInfor]['imageSet']
                    }
                    if (this.countArrAllClientTop > 0) {
                        this.arrTmpArrClientTop = this.clientTopServices.changeDateStringToDecoe(this.arrTmpArrClientTop)
                        this.arrTmpArrClientTop.sort((function(obj1, obj2) {
                            return parseFloat(obj1.dateStringToInit) - parseFloat(obj2.dateStringToInit)
                        }))
                        const newData = this.getDataChangeTabName(this.tabName)
                        this.getNewIndexWhenChangeTab(newData)
                        this.arrAllClientTop.sort((function(obj1, obj2) {
                            return parseFloat(obj1.dateStringToInit) - parseFloat(obj2.dateStringToInit)
                        }))
                        if (page == 'registration') {
                            this.swapIndexRegisAndSlide(this.page, this.arrAllClientTop, this.arrTmpArrClientTop)
                        }
                    } else {
                        const emitIndex: any = {}
                        emitIndex['index'] = 0
                        this.clientTopServices.emitChangeIndex(emitIndex)
                    }
                    // const resetTabName = this.clientTopServices.functReturnTabName();
                    // resetTabName['set'] = 'other';
                    // this.clientTopServices.emitChangeTabName(resetTabName);
                },
            )
        })
    }

    getActiveCount(alignerList, lastPassedAlignerCount) {
        let count = 0
        if (
            alignerList &&
            alignerList.length > 0 &&
            lastPassedAlignerCount > 0
        ) {
            for (let i = 0; i < lastPassedAlignerCount; i++) {
                const currentDate = moment()
                .utc()
                .valueOf()
                if (currentDate >= alignerList[i].startDate) {
                    count = i + 1
                }
            }
        }
        return count
    }

    checkActiveAligner(activeAligner, listAligner){
        if(activeAligner){
            let findActiveAlgner = listAligner.find(ele => {
                return ele._id == activeAligner;
            })
            let aligners = AlignerHelper.computeStates(findActiveAlgner)
            return this.getActiveCount(aligners, findActiveAlgner.lastPassedAlignerCount)
        }
        return null
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/client-detail.component.ts